import React from "react";
import styles from "./TextHeader.module.scss"

export default function TextHeader(props: React.ComponentPropsWithoutRef<"h1">): JSX.Element {
  const {children, className, ...rest} = props;
  return <h1 className={styles.header + ' ' + className} {...rest}>{children}</h1>
}
